import { gql } from '@lcs/shared/api';

export const getPhoneNumbersQuery = gql`
   query GetPhoneNumbers($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      phoneNumbersConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            phoneNumberId
            phoneNumber
            account {
               accountId
               name
            }
            providerId
            isPorted
            openExtension {
               extensionId
               number
               name
            }
            closedExtension {
               extensionId
               number
               name
            }
            schedule {
               scheduleId
               name
            }
            isActive
            location {
               locationId
               name
               houseNumber
               directionalPrefix
               streetName
               streetNameSuffix
               directionalPostfix
               city
               state
               postalCode
               country
               timeZoneId
            }
            datePorted
            isE911Registered
            faxExtension {
               extensionId
               name
               number
            }
            createDate
            createUser {
               name
            }
            updateDate
            updateUser {
               name
            }
            phonesUsingForCallerIdConnection {
               items {
                  extensionPhoneId
                  displayName
                  defaultPhoneNumberId
                  extension {
                     extensionId
                     number
                     name
                  }
               }
            }
            faxesUsingForCallerIdConnection {
               items {
                  extensionFaxId
                  defaultPhoneNumberId
                  extension {
                     extensionId
                     number
                     name
                  }
               }
            }
            displayExtensionNumber
         }
      }
   }
`;
